module.exports = __webpack_public_path__ + "static/media/gestao.875ef4ea.png";